// Маппинг полномочий
export const PERMISSIONS = {
  VIEW_EMPLOYER: 'view_employer',
  VIEW_VACANCY: 'view_vacancy',
  VIEW_CANDIDATE: 'view_candidate',
  VIEW_CHAT: 'view_chat',
  VIEW_DASHBOARD: 'view_dashboard',
  ADD_MANAGER: 'add_manager',
};

// Конфигурация защищенных роутов
export const PROTECTED_ROUTES = {
  '/contractor': PERMISSIONS.VIEW_EMPLOYER,
  '/vacancy': PERMISSIONS.VIEW_VACANCY,
  '/applicants': PERMISSIONS.VIEW_CANDIDATE,
  '/chats': PERMISSIONS.VIEW_CHAT,
  '/': PERMISSIONS.VIEW_DASHBOARD,
  '/add/manager': PERMISSIONS.ADD_MANAGER,
};

// Список полномочий для отображения в UI (только 6)
export const DISPLAY_PERMISSIONS = [
  PERMISSIONS.VIEW_EMPLOYER,
  PERMISSIONS.VIEW_VACANCY,
  PERMISSIONS.VIEW_CANDIDATE,
  PERMISSIONS.VIEW_CHAT,
  PERMISSIONS.VIEW_DASHBOARD,
  PERMISSIONS.ADD_MANAGER,
];

// Лейблы полномочий для отображения
export const PERMISSION_LABELS = {
  [PERMISSIONS.VIEW_EMPLOYER]: 'Просмотр контрагентов',
  [PERMISSIONS.VIEW_VACANCY]: 'Просмотр вакансий',
  [PERMISSIONS.VIEW_CANDIDATE]: 'Просмотр соискателей',
  [PERMISSIONS.VIEW_CHAT]: 'Просмотр чатов',
  [PERMISSIONS.VIEW_DASHBOARD]: 'Просмотр дашборда',
  [PERMISSIONS.ADD_MANAGER]: 'Добавление менеджера',
};
